export const tiposEnvios = {
    whatsapp: 'WhatsApp',
    sms: 'SMS',
    email: 'E-mail',
}